import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { Stack } from "@mui/material";

import { Alert, Divider, Icon, Link, Typography } from "@/components/ui-v2";
import { useBasicData, useIncidents } from "@/hooks";

const DEFAULT_INCIDENT_TITLE =
  "Our team is investigating an issue that may affect your experience.";

export const AppWarnings = () => {
  const { workspace, error } = useBasicData();
  const { incidents } = useIncidents();

  if (error || !workspace) {
    return null;
  }

  if (!incidents || incidents.length === 0) {
    return null;
  }

  const currentIncident = incidents[0];

  return (
    <Alert
      severity="warning"
      icon={<Icon icon={faExclamationCircle} size="small" />}
    >
      <Stack spacing={1} divider={<Divider />}>
        <Typography variant="caption" fontWeight={700}>
          {currentIncident.name || DEFAULT_INCIDENT_TITLE}
        </Typography>
        <Typography variant="caption">
          <span>You can follow the status of this incident </span>
          <Link
            href={currentIncident.url}
            sx={{ fontWeight: "bold", textDecoration: "underline" }}
          >
            here
          </Link>
          <span>.</span>
        </Typography>
      </Stack>
    </Alert>
  );
};
